import { useEffect } from 'react';

export function useHashScroll(offset = 0) {
  useEffect(() => {
    document.documentElement.style.scrollPaddingTop = offset + 'px';
  }, [offset]);

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      const a = (e.target as HTMLElement).closest(
        'a[href^="#"]'
      ) as HTMLAnchorElement | null;

      if (a && a.hash) {
        e.preventDefault(); // keep control

        const id = a.hash.slice(1);
        const el = id ? document.getElementById(id) : null;

        if (!el) return;

        const y = el.getBoundingClientRect().top + window.pageYOffset - offset;

        // Scroll manually with offset
        window.scrollTo({ top: y, behavior: 'smooth' });

        // Keep URL hash
        history.pushState(null, '', a.hash);
      }
    };

    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, [offset]);
}
